"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDicionarName = void 0;
var EDicionarName;
(function (EDicionarName) {
    EDicionarName["Texto"] = "T";
    EDicionarName["Numero"] = "N";
    EDicionarName["Data"] = "D";
    EDicionarName["Logico"] = "L";
})(EDicionarName = exports.EDicionarName || (exports.EDicionarName = {}));
